import { FC, ReactElement, ReactNode, useMemo } from 'react'
import { useLocation, Routes, Route, Navigate } from 'react-router'
import { AnimatedSidebar } from '@/components/navigation/sidebar'
import { NavigationItem, RouteProps } from '@/components/navigation/types'
import { cn } from '@/lib/utils'

type ContainerProps = {
  links: NavigationItem[]
  children: ReactElement<RouteProps>[]
  className?: string
}

const SettingsContainer: FC<ContainerProps> = ({ links, children, className }) => {
  const location = useLocation()
  const cut = useMemo(() => children[0]?.props.path.lastIndexOf('/'), [children])

  return (
    <div className={cn('flex w-full h-full min-h-0', className)}>
      <aside className="flex flex-col h-full min-h-0 border-r bg-background w-60 rounded-l-xl">
        <AnimatedSidebar items={links} />
      </aside>
      <main className="flex flex-col flex-1 w-full min-h-0 p-8 overflow-y-auto">
        <Routes location={location}>
          {children.map(route => (
            <Route key={route.props.path} path={route.props.path.substring(cut)} Component={route.props.Component} />
          ))}
          <Route path="/" element={<Navigate to={children[0]?.props.path || ''} replace />} />
        </Routes>
      </main>
    </div>
  )
}

type ContentProps = {
  children?: ReactNode
  className?: string
}

export const Settings: FC<ContentProps> = ({ children, className }) => (
  <div className={cn('flex flex-col space-y-4 max-w-7xl', className)} data-testid="settings-page">
    {children}
  </div>
)

export default SettingsContainer
